<template>
  <v-container fluid class="pa-0 my-4">
    <v-card>
      <v-card-title class="grey lighten-4 py-0">
        <span class="title primary--text">Client</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" icon flat @click.native="addClient" v-if="clientNameArray.length !== 0">
          <v-icon>add</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <div v-if="clientNameArray.length === 0" class="text-xs-center mt-2">
          <v-btn @click.native="addClient" round color="primary">Add Client</v-btn>
        </div>
        <v-layout row wrap v-else class="px-3">
          <v-flex sm4 v-for="clientName in clientNameArray" :key="clientName">
            <v-chip outline color="primary">
              <v-icon left>contacts</v-icon>
              {{clientName}}
            </v-chip>
            <v-btn color="primary" flat icon @click.native="editClient(clientName)">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-menu v-model="deleteDialogOpen"
              :close-on-content-click="false" v-show="title === 'Edit Client'">
              <v-btn flat dark slot="activator">Delete</v-btn>
              <v-card>
                <v-card-title>
                  <span class="headline error--text">Delete Data</span>
                </v-card-title>
                <v-card-text>
                  Sure you want to delete this record?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" outline round @click.native="deleteDialogOpen = false">No</v-btn>
                  <v-btn color="error" round @click.native="deleteClient" :loading="loading" :disabled="loading">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-btn dark flat @click.native="saveClient" :loading="loading" :disabled="loading">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="clientForm">
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                  <v-text-field name="clientName" label="Client Name" v-model="client.clientName" :rules="rules.clientName" :counter="32" box required>
                  </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="pa-0">
                <h2>How many trainings did you deliver? <strong>{{client.trainingList.length}}</strong></h2>
                <v-btn icon color="primary" flat @click.native="manageTrainingList(null)"><v-icon>add</v-icon></v-btn>
                </v-subheader>
                <v-subheader class="primary--text pa-0">*The below details will be kept confidential.</v-subheader>
              </v-flex>
              <v-flex xs12 v-for="(training, index) in client.trainingList" :key="index">
                <v-container fluid class="pa-0 grey lighten-5">
                  <span class="title grey--text">Training {{index + 1}}</span>
                  <v-btn  icon color="secondary" flat @click.native="manageTrainingList(index)"
                  v-show="client.trainingList.length > 1">
                  <v-icon>close</v-icon>
                  </v-btn>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field name="trainingName" label="Training Name" v-model="training.trainingName" :rules="rules.trainingName" :counter="128" box required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field name="referenceName" label="Reference Name" v-model="training.referenceName" :rules="rules.referenceName" :counter="64" box required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field name="referenceEmailId" label="Reference Email Id"  v-model="training.referenceEmailId" :rules="rules.referenceEmailId" box required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field name="referenceNumber" label="Contact Number" maxlength="10" mask="##########" v-model="training.referenceNumber" :rules="rules.referenceNumber" :counter="10" box required></v-text-field>
                      </v-flex>
                    </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  name: 'ClientCard',
  watch: {
    dialogOpen (val) {
      if (val) {
        if (this.client.clientName === null || this.client.clientName === '' || this.client.clientName === undefined) {
          this.title = 'Add Client'
        } else {
          this.title = 'Edit Client'
        }
      }
    }
  },
  data () {
    return {
      deleteDialogOpen: false,
      title: '',
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        clientName: [
          (v) => !!v || 'Client Name is required',
          (v) => (v && v.length <= 32) || 'Client Name must be less than 32 characters'
        ],
        referenceEmailId: [
          (v) => !!v || 'Reference Email Id is required',
          (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
        ],
        referenceNumber: [
          (v) => !!v || 'Contact number is required',
          (v) => (v && v.length <= 10) || 'Contact number must be less than 10 characters'
        ],
        trainingName: [
          (v) => !!v || 'Training Name is required',
          (v) => (v && v.length <= 128) || 'Training Name must be less than 128 characters'
        ],
        referenceName: [
          (v) => !!v || 'Reference Name is required',
          (v) => (v && v.length <= 64) || 'Reference Name must be less than 64 characters'
        ]
      },
      dialogOpen: false
    }
  },
  created () {
    Store.dispatch('profile/getClientList')
  },
  computed: {
    ...mapState('profile', {
      client: 'client',
      clientList: 'clientList',
      loading: 'loading'
    }),
    clientNameArray () {
      return Object.keys(this.clientList)
    }
  },
  methods: {
    manageTrainingList (index) {
      Store.dispatch('profile/trainingList', index)
    },
    cb () {
      this.$refs.clientForm.reset()
      this.dialogOpen = false
      this.deleteDialogOpen = false
    },
    editClient (clientName) {
      Store.dispatch('profile/updateClientForm', JSON.parse(JSON.stringify(this.clientList[clientName])))
      this.dialogOpen = true
    },
    addClient () {
      Store.dispatch('profile/updateClientForm', null)
      this.$refs.clientForm.reset()
      this.dialogOpen = true
    },
    async deleteClient () {
      await Store.dispatch('profile/deleteClient', {clientName: this.client.clientName, cb: this.cb})
    },
    async saveClient () {
      if (this.$refs.clientForm.validate()) {
        const clientDto = { ...this.client }
        if (this.title === 'Add Client') {
          await Store.dispatch('profile/addClient', { clientDto, cb: this.cb })
        } else {
          await Store.dispatch('profile/editClient', { clientDto, cb: this.cb })
        }
        // this.dialogOpen = false
      }
    },
    cancelForm () {
      Store.dispatch('profile/updateClientForm', null).then(this.cb)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientCard.vue